var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "19px",
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun-invoice-1060968") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Car-insurance---12---Filters",
    transform: "translate(-826.000000, -136.000000)",
    fill: "#FF11D4",
    fillRule: "nonzero",
    stroke: "#F80DDB",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(20.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29-Copy-3",
    transform: "translate(712.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-invoice-1060968",
    transform: "translate(30.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.08440594 14.2156188 10.094802 14.2156188 10.094802 14.4513297 3.08440594 14.4513297"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.08440594 12.5661139 10.094802 12.5661139 10.094802 12.8018248 3.08440594 12.8018248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "3.08440594 10.9166089 10.094802 10.9166089 10.094802 11.1523198 3.08440594 11.1523198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5137129,0.0274356436 L1.36210396,0.0274356436 L0.0142648515,1.37527475 L0.0142648515,15.6270817 L1.36210396,16.9726485 L11.5137129,16.9726485 L12.861552,15.6270817 L12.861552,1.37527475 L11.5137129,0.0274356436 Z M11.5395192,0.385437129 L12.5078459,1.35393218 L11.3040019,1.60131163 L11.5395192,0.385437129 Z M12.625836,15.5280609 L11.4170266,16.7368703 L1.45856129,16.7368703 L0.249751881,15.5280609 L0.249751881,1.47192228 L1.45856129,0.263112871 L11.3223484,0.263112871 L11.0039603,1.90550644 L12.6251459,1.56854455 L12.6253103,15.527901 L12.625836,15.5280609 Z",
    id: "Shape"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.f833a033534cb336795ee8b44ffebf3f.svg";
export { ForwardRef as ReactComponent };